module.exports = __webpack_public_path__ + "img/network-files.358eb5d2.svg";